import { VideoCameraIcon } from '../../icons/VideoCamera'
import { createPortal } from 'react-dom'
import { ProjectLayout } from '../dialog/projectLayout'
import React from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface JoinLiveMeetingProp {
  className: string
  onChange: any
  onKeyDown: any
  showDialog: boolean
  link: string
  importFile: boolean
  handleClose: any
  onClick: any
}

export function JoinLiveMeeting(props: JoinLiveMeetingProp) {
  return (
    <div className={cn('p-6 flex flex-col h-full overflow-y-hidden', props.className)} style={{ maxHeight: '100%' }}>
      <h2 className="mb-1 text-zinc text-[18px]">Join Live Meeting</h2>
      <p className="my-3 text-grey-400 font-light">
        To start transcribing and analyzing a live meeting, just paste the meeting link here:
      </p>
      <div className="flex w-full h-9 my-3">
        <div className="relative grow">
          <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
            <VideoCameraIcon />
          </div>
          <input
            type="url"
            id="default-search"
            className="h-full w-full ps-10 py-2 text-sm placeholder-grey-400 text-grey-400 bg-grey-100 rounded border border-grey-200"
            placeholder="Paste meeting link"
            onChange={props.onChange}
            onKeyDown={props.onKeyDown}
            required
          />
        </div>
      </div>
      {props.showDialog &&
        (createPortal(
          <ProjectLayout link={props.link} importFile={props.importFile} handleClose={props.handleClose} />,
          document.body
        ) as React.ReactPortal)}
      <Button onClick={props.onClick} className="w-full mt-auto">
        Join Meeting
      </Button>
    </div>
  )
}
